import React, { useState } from "react";
import "./Imagecarousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Imagecarousel = ({ images }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
  };

  const handlePrevImage = () => {
    const currentIndex = images.findIndex(
      (img) => img.src === currentImage.src
    );
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentImage(images[prevIndex]);
  };

  const handleNextImage = () => {
    const currentIndex = images.findIndex(
      (img) => img.src === currentImage.src
    );
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentImage(images[nextIndex]);
  };

  return (
    <>
      <Carousel
        className="custom-carousel"
        autoPlay
        interval={5000}
        infiniteLoop
        showThumbs={false}
      >
        {images.map((image, index) => (
          <div key={index} onClick={() => handleImageClick(image)}>
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </Carousel>

      {isModalOpen && (
        <div className="modal">
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <span className="prev" onClick={handlePrevImage}>
            &#10094;
          </span>
          <img
            className="modal-content"
            src={currentImage.src}
            alt={currentImage.alt}
          />
          <span className="next" onClick={handleNextImage}>
            &#10095;
          </span>
        </div>
      )}
    </>
  );
};

export default Imagecarousel;
